import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContainerWrapper from "../../components/ContainerWrapper/ContainerWrapper";
import ActionButton from "../../components/Button/ActionButton";
import HelpContent from "../../components/payments/HelpContent/HelpContent";
import { PAYMENTS_HELP_CONTENT } from "../../constants";
import {
  DASHBOARD_PATH,
  NEW_CONFIGURATION_PATH
} from "../../utils/paymentsRoutes";

/**
 * What the payments service is, shown to a professional who has no account at
 * all — it is what the payments navigation lands on instead of a summary with
 * nothing in it, and it is not shown again once an account exists, however
 * incomplete that account may be.
 *
 * Back therefore leaves the payments area rather than stepping back inside it:
 * there is nothing behind this screen to return to.
 *
 * Unlike the contextual help, this document is a step of the flow, so it is
 * rendered as a full screen with its own continue action.
 */
export default function PaymentConfigurationExplanation() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ContainerWrapper>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <HelpContent linkName={PAYMENTS_HELP_CONTENT.EXPLANATION} />
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
          <ActionButton
            label={t("paymentConfigurations.back")}
            onClick={() => history.push(DASHBOARD_PATH)}
            variant="secondary"
          />
          <ActionButton
            label={t("paymentConfigurations.register")}
            onClick={() => history.push(NEW_CONFIGURATION_PATH)}
          />
        </Box>
      </Box>
    </ContainerWrapper>
  );
}
